import { EnrolmentStatus } from '@/models/enrolment-status';

import { EnrolmentConfirmedTrigger } from './enrolment-confirmed-trigger';

export class EnrolmentPreconfirmedTrigger extends EnrolmentConfirmedTrigger {
	public constructor(excludedEnrolmentStatuses: EnrolmentStatus[]) {
		super(excludedEnrolmentStatuses, 'Preconfirmed');
	}
}
